import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { statNumberToString } from "../../../../apis/transform/stats"
import { Progress } from "antd"
import cx from "classnames"
import style from "./style.module.scss"

export function PlayerDuels({
  duels,
  wonDuels,
  clearances,
  blockShots,
}: {
  duels: number
  wonDuels: number
  clearances?: number
  blockShots?: number
}) {
  return (
    <div className={style.playerDuelsContainer}>
      <Row className={cx(style.playerDuelsRow, style.whiteBg)}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <dt>Duelli</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{statNumberToString(duels)}</dd>
          </Col>
        </dl>
      </Row>
      <Row className={style.playerDuelsRow}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <dt>Duelli vinti</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{statNumberToString(wonDuels)}%</dd>
          </Col>
          <Col>
            <Progress
              percent={wonDuels}
              size="small"
              showInfo={false}
              strokeLinecap={"square"}
              strokeColor={"#f4c400"}
              trailColor="white"
            />
          </Col>
        </dl>
      </Row>
      {clearances && blockShots && (
        <>
          <Row className={style.playerDuelsRow}>
            <dl>
              <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
                <dt>Spazzate</dt>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
                <dd>{statNumberToString(clearances)}</dd>
              </Col>
            </dl>
          </Row>
          <Row className={style.playerDuelsRow}>
            <dl>
              <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
                <dt>Tiri Bloccati</dt>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
                <dd>{statNumberToString(blockShots)}</dd>
              </Col>
            </dl>
          </Row>
        </>
      )}
    </div>
    // <Col className={"colStats"}>
    //   <Row>
    //     <Col sm={clearances && blockShots ? 6 : 12} className={"centerColumn"}>
    //       <Row className={"paddingBottom20"}>
    //         <Col className={"centerColumn"}>
    //           <Row>
    //             <Col className={"competitionSeasonValueLarge"}>{statNumberToString(duels)}</Col>
    //           </Row>
    //           <Row>
    //             <Col className={"competitionSeasonLabel"}>
    //               <h2>Duelli</h2>
    //             </Col>
    //           </Row>
    //         </Col>
    //       </Row>
    //       <Row className={"paddingTop20"}>
    //         <Col className={"centerColumn"}>
    //           <Row>
    //             <Col className={"competitionSeasonValue"}>{`${statNumberToString(wonDuels)}%`}</Col>
    //           </Row>
    //           <Row>
    //             <Col>
    //               <Progress
    //                 className={"paddingLeftRight15"}
    //                 percent={wonDuels}
    //                 size="small"
    //                 showInfo={false}
    //                 strokeLinecap={"square"}
    //                 strokeColor={"#f4c400"}
    //               />
    //             </Col>
    //           </Row>
    //           <Row>
    //             <Col className={"competitionSeasonLabel"}>
    //               <h2>Duelli vinti</h2>
    //             </Col>
    //           </Row>
    //         </Col>
    //       </Row>
    //     </Col>
    //     {clearances && blockShots && (
    //       <Col sm={6} className={"centerColumn leftBorder"}>
    //         <Row className={"paddingBottom20"}>
    //           <Col className={"centerColumn"}>
    //             <Row>
    //               <Col className={"competitionSeasonValueLarge"}>{statNumberToString(clearances)}</Col>
    //             </Row>
    //             <Row>
    //               <Col className={"competitionSeasonLabel"}>
    //                 <h2>Spazzate</h2>
    //               </Col>
    //             </Row>
    //           </Col>
    //         </Row>
    //         <Row className={"paddingTop20"}>
    //           <Col className={"centerColumn"}>
    //             <Row>
    //               <Col className={"competitionSeasonValueLarge"}>{`${statNumberToString(blockShots)}`}</Col>
    //             </Row>
    //             <Row>
    //               <Col className={"competitionSeasonLabel"}>
    //                 <h2>Tiri Bloccati</h2>
    //               </Col>
    //             </Row>
    //           </Col>
    //         </Row>
    //       </Col>
    //     )}
    //   </Row>
    // </Col>
  )
}
